<template>
  <tree-view :key="treeKey" id="customtree" :initial-model="tempData">
    <template #text="{ model }">
      <em :title="model.treeNodeSpec.title">
        <div v-if="model.style === 'directory'">
          <i class="bi bi-folder-fill"> </i>
          <span>
            {{ model[model.treeNodeSpec.labelProperty] }}
          </span>
        </div>
        <div v-else="model.style === 'file'">
          <i class="bi bi-file-earmark-fill"> </i>
          <span>
            {{ model[model.treeNodeSpec.labelProperty] }}
          </span>
        </div>
      </em>
    </template>
  </tree-view>
</template>

<script setup lang="ts">
import "../../../node_modules/@grapoza/vue-tree/dist/style.css";
import { useContentStore } from "@/stores/content_review/content";
import { useFolderStructureStore } from "@/stores/folder_structure";
import { TreeView } from "@grapoza/vue-tree";
import { useAsyncState } from "@vueuse/core";
import { ref, watch } from "vue";
import { useRouter } from "vue-router";

const selectedId = ref();
const treeKey = ref(0);
const folderStructureStore = useFolderStructureStore();
const contentStore = useContentStore();
const tempData = ref([]);
const router = useRouter();

const forceRerender = () => {
  treeKey.value += 1;
};

watch(
  () => contentStore.currentContent?.id,
  () => {
    if (contentStore.currentContent?.contentType == "Transfer" ) {
      execute();
    }
  }
);

watch(
  () => folderStructureStore.convertedStructure,
  () => {
    tempData.value = folderStructureStore.convertedStructure;
    forceRerender();
  }
);

const { execute } = useAsyncState(() => {
  if (contentStore.currentContent?.contentId) {
    selectedId.value = contentStore.currentContent.contentId;
  } else {
    selectedId.value = router.currentRoute.value.params.selectedTransferId;
  }
  return folderStructureStore.fetchFolderData(selectedId.value);
}, null);
</script>

<style scoped>
.bi-folder-fill {
  color: #ffc700;
  font-size: 18px;
  padding-right: 5px;
}
.bi-file-earmark-fill {
  font-size: 16px;
  padding-right: 5px;
}
</style>
